module.exports = __webpack_public_path__ + "img/chimeBank.2bf8a537.png";